//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum BillingRollStockSparePartMode {
	RollStockData = 0,
	ProductData = 1,
	ProductAndRollStockData = 2,
	RollStockAndProductData = 3
}
